import {
  Avatar,
  Box,
  Center,
  Heading,
  Text,
  Stack,
  Button,
  Link,
  useColorModeValue,
} from '@chakra-ui/react';

export default function SocialProfile() {
  return (
    <Center py={6}>
      <Box
        maxW={'350px'}
        w={'full'}
        bg={useColorModeValue('pastelWhite', 'gray.900')}
        boxShadow={'2xl'}
        rounded={'lg'}
        p={6}
        textAlign={'center'}
      >
        <Avatar
          size={'xl'}
          src={'/assets/images/profile.jpg'}
          alt={'Suzan Cook'}
          mb={4}
          pos={'relative'}
        />
        <Heading fontSize={'2xl'} fontFamily={'heading'} color={'pastelBlue'}>
          Suzan Cook
        </Heading>
        <Text fontWeight={600} color={'gray.500'} mb={4}>
          Wife, mother, teacher, and passionate Bible student.
        </Text>
        <Text
          textAlign={'center'}
          color={useColorModeValue('gray.700', 'gray.400')}
          px={3}
        >
          Discover the joy of God’s word with me.
        </Text>

        <Stack mt={8} direction={'row'} spacing={4}>
          {/* Updated Button for Formspree */}
          <Button
            flex={1}
            fontSize={'sm'}
            rounded={'full'}
            bg={'pastelPink'}
            color={'white'}
            _hover={{
              bg: 'pastelBlue',
            }}
            as={Link}
            href={'/contact'}
          >
            Message
          </Button>
          <Button
            flex={1}
            fontSize={'sm'}
            rounded={'full'}
            bg={'pastelGreen'}
            color={'white'}
            _hover={{
              bg: 'pastelYellow',
            }}
            as={Link}
            href={'https://linktr.ee/suzan.cook'}
            isExternal
          >
            Follow
          </Button>
        </Stack>
      </Box>
    </Center>
  );
}
